import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { DEFAULT_PRIORITIES, DEFAULT_BRANCHES } from "@/lib/api";

const SettingsContext = createContext(null);

const DEFAULT_CALL_TYPES = [
  { id: "structure_fire", label: "Structure Fire", branch: "FIRE" },
  { id: "medical_emergency", label: "Medical Emergency", branch: "EMS" },
  { id: "traffic_accident", label: "Traffic Accident", branch: "EMS" },
  { id: "active_shooter", label: "Active Shooter", branch: "PD" },
  { id: "robbery", label: "Robbery in Progress", branch: "PD" },
  { id: "severe_weather", label: "Severe Weather", branch: "WEATHER" },
];

export function SettingsProvider({ children }) {
  const [callTypes, setCallTypes] = useState(DEFAULT_CALL_TYPES);
  const [branches, setBranches] = useState(DEFAULT_BRANCHES);
  const [priorities, setPriorities] = useState(DEFAULT_PRIORITIES);

  const load = useCallback(async () => {
    try {
      const [ct, br, pr] = await Promise.all([
        api.get("/settings/call_types"),
        api.get("/settings/branches"),
        api.get("/settings/priorities"),
      ]);
      setCallTypes(ct.data.items);
      setBranches(br.data.items);
      setPriorities(pr.data.items);
    } catch { /* ignore */ }
  }, []);

  useEffect(() => { load(); }, [load]);

  const update = async (name, items) => {
    await api.put(`/settings/${name}`, { items });
    if (name === "call_types") setCallTypes(items);
    if (name === "branches") setBranches(items);
    if (name === "priorities") setPriorities(items);
  };

  const reset = async (name) => {
    const { data } = await api.post(`/settings/${name}/reset`);
    if (name === "call_types") setCallTypes(data.items);
    if (name === "branches") setBranches(data.items);
    if (name === "priorities") setPriorities(data.items);
  };

  return (
    <SettingsContext.Provider value={{ callTypes, branches, priorities, reload: load, update, reset }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
